"use client";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import logo from './Assets/rentastic.png';


import Header from '../Header';
import Footer from '../Footer';

const PrivacyPolicy = () => {
   useEffect(() => {
        window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
      }, []);
     

  return (
    <div>
     <div className="w-full">
        <Header />
      </div>
    <main className="flex gap-7 p-10 w-full min-h-screen bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
      {/* <div className="flex-shrink-0 w-[285px] max-xl:w-full">
        <FilterSidebar />
      </div> */}

      <section className="flex flex-col flex-1 gap-5 min-w-0">
        <div className="bg-gray-50 min-h-screen pl-6">
      {/* Privacy Policy Heading */}
      
<h2
  className="
    text-lg sm:text-xl md:text-xl lg:text-xl
    font-semibold
    text-gray-800
    mb-4 sm:mb-6
    text-center sm:text-left
    pl-0 sm:pl-8 md:pl-10 lg:pl-[36px]
    ml-0 sm:ml-8 md:ml-14
  "
>
  Privacy Policy
</h2>


      {/* Card */}
      
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mx-auto">
        {/* Logo + Title Centered (side by side) */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <img
            src="https://cdn.acsdev.in/Rentastic/rentastic.png"// replace with your actual logo path
            alt="Rentastic Toys"
            className="w-16 h-16"
          />
          <h2 className="text-2xl font-bold">Rentastic Toys</h2>
        </div>

        {/* Content */}
        <div className="space-y-5 text-gray-700 leading-relaxed">
          <h1>Rentastic Toys (“Company”, “we”, or “us”) is committed to protecting your privacy. This Privacy Policy describes how we collect, use, share, and protect personal information
             obtained through our website, mobile application, and services (“Platform”).</h1>
          <p> By using the Platform, Customers consent to the practices described in this Privacy Policy. </p>
          <p>

            <strong>1.Personal Information We Collect
              </strong> <br/>We collect personal information necessary to operate and deliver our toy-rental subscription services, including:
                <ul className='list-disc list-inside pl-3'>
                <li>
                Customer name
                </li>
                <li>	Email address</li>
                <li>	Phone number</li>
                <li>	Delivery address</li>
                <li>	Payment authorization details</li>
              </ul> 
          </p>

          <p>
            <strong>2.Use of Information</strong> <br/>Collected information is used to:
            <ul className='list-disc list-inside pl-3'>

              <li>Process and manage subscriptions</li>
              <li>	Deliver and retrieve toys</li>
              <li>	Provide account support and notifications</li>
              <li>	Communicate service-related changes or updates</li>
            </ul>
            Marketing communications may be sent to Customers but may be opted out of at any time.
          </p>

          <p>
            <strong>3.Data Security and Third-Party Processing</strong><ul>
              <li>Payment information is processed securely by PCI-compliant third-party payment providers such as Stripe, Apple Pay, or Google Pay.
                 Rentastic Toys does not store full credit-card details.</li>
              <li>Information is shared only with service providers necessary to support operations (e.g., delivery partners).
                 We do not sell or rent personal information to third-party marketers.</li>
              <li>Reasonable administrative, technical, and physical safeguards are used to maintain data protection.</li>
            </ul>
          </p>

          <p>
            <strong>4. Children’s Privacy</strong><br/> Rentastic Toys does not knowingly collect personal data from children.
             Parents are responsible for ensuring that any information submitted does not include children’s identifiable information.
              We comply with the Children’s Online Privacy Protection Act (COPPA).
          </p>

          <p>
            <strong>5. Rights of Customers</strong> <br/>Customers may request access to, correction of, or deletion of their personal information by contacting Customer Support.
             Upon subscription termination and settlement of outstanding charges, Customer information will be removed from active use in accordance with applicable laws.</p>

          <p>
            <strong>6. Policy Updates</strong><br/>This Privacy Policy may be revised periodically.
             Continued use of the Platform after updates constitutes acceptance of the revised policy.</p>

          <p>
            <strong>7.Contact</strong> <br/>For privacy inquiries:<br/>
            Email : <strong>rentastictoys@gmail.com </strong><br/>
          </p>
          <p>
            Continued use of our Platform confirms your consent to this Privacy Policy.
          </p>
        </div>
      </div>
    </div>

       
      </section>
    </main>
    <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
